<template>
	<div class="header" :class="{isRecharge:status!='isIndex'}">
		<div class="gw">
			<router-link to="/" class="logo">
				<img src="../assets/3.png" alt="">
			</router-link>
			<ul :class="{isRecharge:status!='isIndex'}">
				<li :class="{on:status=='isIndex'}" ><router-link to="/">首页</router-link></li>
				<li class="li-line">|</li>
				<li :class="{on:status=='isRecharge'||status=='isPaySuccess',ori:status == 'isRecharge'||status=='isPaySuccess'}"><router-link to="/recharge">充值</router-link></li>
				<li class="li-line">|</li>
        <li :class="{on:status=='isUploadMusic',ori:status=='isUploadMusic'}"><router-link to="/upload_music">上传音乐或视频</router-link></li>
			</ul>
		</div>
	</div>
</template>
<script>
	import store from '@/store/store'
	export default {
		name: 'topHeader',
		data () {
			return {
			}
		},
		computed:{
			status(){
				return this.$store.state.status;
			}
		},
		created:function() {
		}
	}
</script>
<style scoped>
	.header{
		width:100%;
		height: 80px;
		position:absolute;
		top: 0;
		z-index: 99;
	}
	.header.isRecharge{
		box-shadow: 0 4px 6px 0 rgba(0,0,0,0.05);
	}

	.logo img{
		float: left;
    width: auto;
		height: 60px;
		margin-top: 10px;
    outline: none;
    border: 0px;
	}
	.header ul{
		margin-top: 28px;
		float: right;
	}
	.header ul li{
		display:inline-block;
		padding: 0 20px;
		border-radius: 1px;
		opacity: 0.65;
		color: #161A25;
	}
	.header ul li a{
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		color: #161A25;
		letter-spacing: 0;
		text-align: left;
		text-decoration: none;
	}

	.header ul li:hover,.header ul li.on{
		opacity: 1;
	}

	.header ul li.on a{
		border-bottom: 2px solid #161A25;
		padding-bottom: 2px;
		border-radius: 1px;
	}
	.header ul li.ori a{
		border-bottom: 2px solid #FF8700;
		padding-bottom: 2px;
		border-radius: 1px;
	}
	
	.header ul.isRecharge li.on a{
		border-color: #232323;
	}
	.header ul.isRecharge li a,.header ul.isRecharge li{
		color: #232323;
	}
	.header ul.isRecharge li.ori a{
		color: #FF8700;
		border-bottom: 2px solid #FF8700;
	}
	.header ul li.li-line{
		padding: 0 5px;
	}

</style>



// WEBPACK FOOTER //
// src/components/header.vue